var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticClass:"icon blog",attrs:{"viewBox":"0 0 24 24"}},[_c('path',{attrs:{"d":"M5.1,3.9h13.9c0.6,0,1.2,0.5,1.2,1.2v13.9c0,0.6-0.5,1.2-1.2,1.2H5.1c-0.6,0-1.2-0.5-1.2-1.2V5.1\n        C3.9,4.4,4.4,3.9,5.1,3.9z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M4.2,9.3h15.6"}}),_vm._v(" "),_c('path',{attrs:{"d":"M9.1,9.5v10.3"}})])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3506fcd8","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/footer/MobileNavbar/svgs/SvgBlog.vue
// module id = hmF3
// module chunks = 0